import { Links } from 'types/links';

export enum ButtonType {
  submit = 'submit',
  button = 'button',
  reset = 'reset',
}

export enum ButtonSize {
  s = 's',
  m = 'm',
}

export enum ButtonVariant {
  contained = 'contained',
  outlined = 'outlined',
}

export interface PropsButton {
  type: ButtonType;
  children?: React.ReactNode;
  href?: Links | string;
  size?: ButtonSize;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  className?: string;
  disabled?: boolean;
  variant?: ButtonVariant;
  loading?: boolean;
  leftIcon?: JSX.Element;
  rightIcon?: JSX.Element;
  isSubmitSuccessful?: boolean;
}
